import styled from 'styled-components/macro';

const DetailView = styled('div')`
  padding: 5px 20px;
`;

export default DetailView;
